import React from "react";
import { Row, Typography, Form, Col, Divider, Select } from "antd";
import { labelConfig } from "../../../glAndAccounting.config";
import { BOM } from "../../../../../services/definedMethod";
const { Title, Text } = Typography;

const CurrencyConfigurationForm = (props) => {
  const { onFinish, form, formData, templateData } = props;

  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.currencyInfo}
        </Title>
      </Divider>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="currencyCode"
            label={<Text strong>Currency Code</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Currency Code"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Currency Code")}
              showSearch
              options={templateData.currencyCodeOptions}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="multiCurrencyAllowed"
            label={<Text strong>Multi Currency Allowed</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Multi Currency Allowed"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Multi Currency Allowed")}
              options={templateData.yesOrNo}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="revaluationRequired"
            label={<Text strong>Revaluation Required</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Revaluation Required"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Revaluation Required")}
              options={templateData.yesOrNo}
            />
          </Form.Item>
        </Col>
      </Row>
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          name="revaluationGlAccountId"
          label={<Text strong>Revaluation GL Account</Text>}
          rules={[
            {
              required: true,
              message: BOM.CheckReqFld("Revaluation GL Account"),
            },
          ]}
        >
          <Select
            placeholder={BOM.handlePlaceholderMsg("Revaluation GL Account")}
            showSearch
            options={templateData.revaluationGlAccountOptions}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            allowClear
          />
        </Form.Item>
      </Col>
    </Form>
  );
};

export default CurrencyConfigurationForm;
